<div class="pills">
  @for (pill of pills(); track pill.value) {
    <div
      class="pill"
      [class.active]="pill.value === selectedPill()"
      [class.disabled]="disabled()"
      (click)="selectPill(pill.value)">
      {{ pill.label | translate }}
    </div>
  }
</div>